var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-1 ma-1 elevation-7",attrs:{"color":"primary"}},[_c('v-toolbar',{staticClass:"primary--text",attrs:{"dense":""}},[_c('v-toolbar-title',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.groupTitle))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }